// let env = 'dev';
let env = 'production';
let appName = "ehstools";
let envMap = {
    dev: {
        baseURL: window.location.origin
    },
    production: {
        baseURL: window.location.origin
    }
};
export default {
    baseURL: envMap[env]['baseURL'],
    env,
    appName
}
